export const productMasterEndpoints = (builder) => ({
  // LIST: paginated product master
  getProducts: builder.query({
    query: (args = {}) => {
      const {
        pageNumber = 1,
        pageSize = 10,
        searchTerm,
        searchValue,
        fetchAll,
        sortBy,      // optional: 'ProductName' for dropdown, undefined for list view
        insurerId,   // optional: filter by insurer at DB level (for dropdown)
      } = args;

      const params = { pageNumber, pageSize };
      if (searchTerm  !== null && searchTerm  !== undefined) params.searchTerm  = searchTerm;
      if (searchValue !== null && searchValue !== undefined) params.searchValue = searchValue;
      if (fetchAll    !== null && fetchAll    !== undefined) params.fetchAll    = fetchAll;
      if (sortBy      !== null && sortBy      !== undefined) params.sortBy      = sortBy;
      if (insurerId   !== null && insurerId   !== undefined) params.insurerId   = insurerId;

      return {
        url: '/life-Insurance/get-product-list',
        method: 'GET',
        params,
      };
    },
    transformResponse: (response) => ({
      data: response?.data ?? [],
      totalCount: response?.totalCount ?? 0,
      success: !!response?.success,
      message: response?.message ?? '',
    }),
    providesTags: (result) => {
      if (!result || !Array.isArray(result.data)) return ['Product'];
      const itemTags = result.data.map((p) => {
        const id = p.ProductID ?? p.ProductId ?? p.id ?? null;
        return { type: 'Product', id };
      });
      return [...itemTags, { type: 'Product', id: 'LIST' }];
    },
  }),

  // GET BY ID  -> matches router.get('/:id', ...)
  getProductById: builder.query({
    query: (id) => ({
      url: `/life-Insurance/get-product/${id}`,
      method: 'GET',
    }),
    transformResponse: (response) => ({
      success: !!response?.success,
      message: response?.message ?? '',
      data: response?.data ?? null,
    }),
    providesTags: (result, error, id) => [{ type: 'Product', id }],
  }),

  // CREATE (or upsert via Mode) -> matches router.post('/product', ...)
  saveProduct: builder.mutation({
    query: (body) => ({
      url: '/life-Insurance/createOrUpdate-product',
      method: 'POST',
      body,
    }),
    invalidatesTags: [{ type: 'Product', id: 'LIST' }, 'Product'],
  }),

  // UPDATE (alias to save endpoint) -> use same endpoint as save (POST /product)
  updateProduct: builder.mutation({
    query: (body) => ({
      url: '/life-Insurance/createOrUpdate-product',
      method: 'POST',
      body,
    }),
    invalidatesTags: (result, error, arg) => {
      const id = (result && (result.ProductID ?? result.ProductId)) || arg?.ProductID || arg?.ProductId;
      return id ? [{ type: 'Product', id }, { type: 'Product', id: 'LIST' }] : [{ type: 'Product', id: 'LIST' }];
    },
  }),

  // DELETE single -> matches router.delete('/:id', ...)
  deleteProduct: builder.mutation({
    query: (id) => ({
      url: `/life-Insurance/delete-product/${id}`,
      method: 'DELETE',
    }),
    invalidatesTags: (result, error, id) => [{ type: 'Product', id }, { type: 'Product', id: 'LIST' }],
  }),

  // BULK DELETE -> matches router.post('/bulk-delete', ...)
  bulkDeleteProducts: builder.mutation({
    query: (payload) => ({
      url: '/life-Insurance/bulk-delete-product',
      method: 'POST',           // note: backend uses POST for bulk-delete
      body: payload,            // expect { ids: [1,2,3] }
    }),
    invalidatesTags: [{ type: 'Product', id: 'LIST' }, 'Product'],
  }),

  // GET ALL OPTIONS
  getAllOptions: builder.query({
    query: () => ({
      url: '/life-Insurance/get-options',
      method: 'GET',
    }),
    transformResponse: (response) => ({
      success: !!response?.success,
      data: response?.data ?? [],
      message: response?.message ?? '',
    }),
  }),

  // GET ALL FUNDS
  getAllFunds: builder.query({
    query: () => ({
      url: '/life-Insurance/get-funds',
      method: 'GET',
    }),
    transformResponse: (response) => ({
      success: !!response?.success,
      data: response?.data ?? [],
      message: response?.message ?? '',
    }),
  }),
});
